import {Component, Input} from "@angular/core";

import {faTimes} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'chip',
    imports: [FontAwesomeModule, FormsModule],
    templateUrl: './chip.html'
})
export class ChipComponent {
  @Input('text') text: string = '';
  faTimes = faTimes;

  ngOnInit() {
    console.log(this.text);
  }
}
